export const IMAGE_SIZES = [
  "(min-width: 1310px) 544px",
  "(min-width: 1120px) 272px",
  "(min-width: 1010px) 544px",
  "272px",
].join();
